import { useRef } from "react";
import { Button } from "antd";
import { CameraOutlined, PaperClipOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../useIsMobile";

export const EVIDENCE_ACCEPT = ".pdf,.jpg,.jpeg,.png,.heic,.heif,.docx,.xlsx";
const FILE_ACCEPT = `${EVIDENCE_ACCEPT},image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;

const hidden: React.CSSProperties = { position: "absolute", width: 0, height: 0, opacity: 0, pointerEvents: "none" };

/** «Scatta foto» (fotocamera posteriore) e «Scegli file» (galleria o documenti). */
export function FilePicker(props: { onFiles: (files: File[]) => void; multiple?: boolean; disabled?: boolean }) {
  const { onFiles, multiple = true, disabled } = props;
  const { t } = useTranslation();
  const mobile = useIsMobile();
  const cam = useRef<HTMLInputElement>(null);
  const files = useRef<HTMLInputElement>(null);
  const touch = typeof navigator !== "undefined" && navigator.maxTouchPoints > 0;
  const showCam = mobile || touch;
  const h = (e: React.ChangeEvent<HTMLInputElement>) => {
    const l = Array.from(e.target.files ?? []);
    e.target.value = ""; // permette di riscegliere lo stesso file
    if (l.length) onFiles(l);
  };
  const size = mobile ? "large" : "middle";
  const st: React.CSSProperties = mobile ? { height: 48, flex: 1 } : {};
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      {showCam ? (
        <>
          <input ref={cam} type="file" accept="image/*" capture="environment" multiple={multiple} onChange={h} style={hidden} tabIndex={-1} aria-hidden />
          <Button size={size} icon={<CameraOutlined />} disabled={disabled} onClick={() => cam.current?.click()} style={st}>
            {t("b_take_photo")}
          </Button>
        </>
      ) : null}
      <input ref={files} type="file" accept={FILE_ACCEPT} multiple={multiple} onChange={h} style={hidden} tabIndex={-1} aria-hidden />
      <Button size={size} icon={<PaperClipOutlined />} disabled={disabled} onClick={() => files.current?.click()} style={st}>
        {multiple ? t("b_choose_files") : t("b_choose_file")}
      </Button>
    </div>
  );
}
